var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoomMeasurementsGreyAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 127,
    viewBox: "0 0 129 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.7405 3.35938L126.48 39.5494L126.47 89.9194L63.7305 53.7394L63.7405 3.35938Z",
    fill: "white",
    stroke: "#020201",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.49 89.9205L63.75 53.7305L1 89.9805L63.74 125.98L126.48 89.9205H126.49Z",
    fill: "white",
    stroke: "#020201",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.273 0.13C62.123 0.04 62.043 0 61.973 0C61.913 0 61.863 0.04 61.833 0.08C61.793 0.13 61.793 0.22 61.793 0.4V5.91C61.793 5.91 61.813 5.96 61.833 5.98C61.853 6 61.883 6.02 61.943 6.05L127.953 44.08C128.103 44.17 128.183 44.21 128.243 44.21C128.303 44.21 128.353 44.17 128.383 44.13C128.423 44.08 128.423 43.99 128.423 43.81V38.35C128.423 38.18 128.423 38.1 128.403 38.03C128.383 37.96 128.343 37.9 128.293 37.84C128.243 37.78 128.173 37.74 128.023 37.66L62.273 0.13Z",
    fill: "#ADBDC9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0792 90.1712C10.7392 89.9812 10.7392 89.4913 11.0792 89.3013L63.3692 59.1912C63.5992 59.0613 63.8792 59.0613 64.1192 59.1912L116.609 89.0513C116.949 89.2413 116.949 89.7312 116.609 89.9212L63.7892 120.011C63.7892 120.011 63.7192 120.031 63.6892 120.011L11.0792 90.1712Z",
    fill: "#C7D3DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7305 125.98V75.7305L126.47 39.4805V89.9205L63.7305 125.98Z",
    stroke: "#020201",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.73 3.48828V53.7383L1 89.9783V39.5383L63.73 3.48828Z",
    fill: "white",
    stroke: "#020201",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5508 29.2891L90.5208 37.4291V52.9791L76.5508 45.0191V29.2891Z",
    stroke: "#020201",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2305 41.8906L112.2 50.0306V65.5806L98.2305 57.6206V41.8906Z",
    stroke: "#020201",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7906 74.6516C26.7206 74.6916 26.6406 74.6516 26.6406 74.5616V45.5016C26.6406 45.4316 26.6806 45.3616 26.7406 45.3316L40.3006 37.6416C40.4306 37.5616 40.6006 37.6616 40.6006 37.8116V66.6116C40.6006 66.6116 40.5806 66.6816 40.5506 66.7016L26.7906 74.6516Z",
    fill: "#ADBDC9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M126.49 39.5494L63.74 3.35938L1 39.6094L63.74 75.6094L126.48 39.5494H126.49Z",
    stroke: "#020201",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomMeasurementsGreyAlt);
export default __webpack_public_path__ + "static/media/room_measurements_grey_alt.e62a01880c06c10bf195473a49d3a029.svg";
export { ForwardRef as ReactComponent };